import React from "react";

import Grid from "@material-ui/core/Grid";
import MobileStepper from '@material-ui/core/MobileStepper';
import {BackButton} from "#/commons/components/forms/BackButton";
import {SaveButton} from "#/commons/components/forms/SaveButton";
import {ForecastMultizoneMeteoForm} from "#/backoffice/forecast/components/ForecastMultizoneMeteoForm";
import MapWeatherFormComponent from "#/commons/map/MapWeatherFormComponent";
import { NextButton } from "#/commons/components/forms/NextButton";


export const StepPrevisioniMeteoTomorrow = (props) => {
  const formData = props.formData;
  const map = !!props.maps && props.maps.length > 0 ? props.maps[1] : null;
  const tomorrowDate = !!formData && !!formData.tomorrow && !!formData.tomorrow.date_short ? formData.tomorrow.date_short || '' : '';
  const currentDay = "tomorrow";

    const handleNextStep = () => {
      props.handleNext();

  }

  return (
      <>
        <div className="row justify-content-center">
          <h2>{props.stepLabel + ' ' + tomorrowDate}</h2>
        </div>
        <Grid container spacing={1}>
          <Grid item xs={4}>
              {!!map &&
                <MapWeatherFormComponent
                  id={map.Id}
                  key={'tomorrow' + map.mapKey}
                  geoJSON={map.shapesGeoJSON}
                  width={map.width || "25vw"}
                  height={map.height || "60vh"}
                  mapKey={map.mapKey}
                  currentDay={'tomorrow'}
                  getColorById={(id) => {return null}}
                  onDragEnd={(key,latlng) => props.onDragEnd('tomorrow',key, latlng)}
                  onRightClick={(key) => props.onRightClick('tomorrow',key)}
                  onDoubleClick={(key) => props.onDoppioClick('tomorrow',key)}

                />
              }
          </Grid>
          <Grid item xs={8}>
            {!!map &&
            <ForecastMultizoneMeteoForm
                viewMode={props.viewMode}
                labelForm={map.labelForm + tomorrowDate}
                zones={map.zones}
                currentDay={currentDay}
                onFormChange={props.onFormChange}
                formData={formData.tomorrow}
                onIconSelected={iconKey => props.onIconSelected('tomorrow',iconKey)}

            />
            }
          </Grid>
        </Grid>
        <MobileStepper
          style={{backgroundColor: 'rgba(255,0,0,0.0)'}}
          position="static"
          variant="text"
          activeStep={props.activeStep}
          steps={props.totalSteps}
          nextButton={
              <NextButton
                variant="contained"
                color="primary"
                onClick={handleNextStep}
                textbutton={props.textNextButton}
              />
          }
          backButton={
              <BackButton
                variant="contained"
                disabled={props.disableBackButton}
                onClick={props.handleBack}
              />
          }
        />
      </>
    );
  };
